import { GovernmentCompanyAdditionalInfo } from "./governmentCompanyAdditionalInfo";

export class CreateFinanceClientRequest {
    id: number;
    username: string;
    address: string;
    country: string;
    post: string;
    password: string;
    firstName: string;
    name: string;
    note: string;
    email: string;
    phone: string;
    mobilePhone: string;
    fax: string;
    customer1: string;
    customer2: string;
    startState: number | null;
    indetificationNumber: string;
    pib: string;
    sendEmail: boolean;
    isSrbClient: boolean;
    isGovernmentCompany:boolean;
    governmentCompanyAdditionalInfo?: GovernmentCompanyAdditionalInfo;


    constructor(formValue) {
        this.id = 0;
        this.address = formValue.address;
        this.country = formValue.country;
        this.customer1 = formValue.customer1;
        this.customer2 = formValue.customer2;
        this.email = formValue.email;
        this.fax = formValue.fax;
        this.firstName = formValue.firstName;
        this.indetificationNumber = formValue.indetificationNumber;
        this.isSrbClient = formValue.isSrbClient;
        this.mobilePhone = formValue.mobilePhone;
        this.name = formValue.name;
        this.note = formValue.note;
        this.password = formValue.password;
        this.phone = formValue.phone;
        this.pib = formValue.pib;
        this.post = formValue.post;
        this.sendEmail = formValue.sendEmail;
        this.startState = formValue.startState;
        this.username = formValue.username;
        this.isGovernmentCompany = formValue.isGovernmentCompany
        
        if (formValue.isGovernmentCompany && formValue.governmentCompanyAdditionalInfo) {
            this.governmentCompanyAdditionalInfo = new GovernmentCompanyAdditionalInfo(
              formValue.governmentCompanyAdditionalInfo
            );
          }
    }
}
